// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6155bcb8","845":"bfbe95dc"}[chunkId] + ".chunk.js";
};